import { Component, OnInit, HostListener } from '@angular/core';
import { CaseDialogComponent } from '../case-dialog/case-dialog.component';
// import { MatDialog, MatDialogConfig } from '@angular/material';
import { HomeService } from '../_services/home.service';
import { Header } from '../_model/header';
import {Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../_services/index';
export let checkPasswordModal = false;
export let checkCaseModal = false;
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public innerWidth: any;
  header: Header;
  screenHeight: any;
  screenWidth: any;
  image: any;
  authConfig: any = {};
  loginSamlUrl: any;
  returnUrl: string;
  checkPasswordModal: boolean = false;
  checkCaseModal: boolean = false;
  allowModifyPwd: string;
  isUserLoggedIn: boolean;
  largeImage: any;
  smallImage: any;
  navigate: any;
  // isSamlLogin: string;

  constructor(
    // private dialog: MatDialog,
    private homeService: HomeService,
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService) {
    this.getScreenSize();

  }

  @HostListener('window:resize', ['$event'])
  getScreenSize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
      if (this.screenWidth <= 768) {
        this.image = this.smallImage;
      } else {
        this.image = this.largeImage;
      }
  }
  

  ngOnInit() {
    this.redirect();
    // this.getLoginConfig();
    this.getHeaderConfig();
    // this.isSamlLogin = localStorage.getItem('isSamlLogin');
    // this.isSamlLogin = this.authenticationService.getValueInConfigFromLocalStorage('isSamlLogin');
    this.allowModifyPwd = this.authenticationService.getValueInConfigFromLocalStorage('allowModifyPwd');

    /* Open Create Case Modal Post Login */
    this.homeService.openCreateCaseModal.subscribe((val) => {
      if (val) {
        this.checkCaseModal = true;
      }
    });

    this.isUserLoggedIn = this.authenticationService.isUserLoggedIn();
    // let showCreateCaseModal = localStorage.getItem('showCreateCaseModal');
    // let isUserLoggedIn = this.authenticationService.isUserLoggedIn();
    // if (showCreateCaseModal !== null && showCreateCaseModal === 'yes' && isUserLoggedIn) {
    //   this.checkCaseModal = true;
    //   localStorage.removeItem('showCreateCaseModal');
    // }
  }

  ngAfterViewChecked() {
    // this.isSamlLogin = this.authenticationService.getValueInConfigFromLocalStorage('isSamlLogin');
    this.allowModifyPwd = this.authenticationService.getValueInConfigFromLocalStorage('allowModifyPwd');
    this.isUserLoggedIn = this.authenticationService.isUserLoggedIn();
  }
  // openCaseDialog() {
  //   const dialogConfig = new MatDialogConfig();

  //   dialogConfig.disableClose = true;
  //   dialogConfig.autoFocus = true;

  //   const dialogRef = this.dialog.open(CaseDialogComponent,
  //     dialogConfig);


  //   dialogRef.afterClosed().subscribe(
  //     val => console.log('Dialog output:', val)
  //   );

  // }

  getHeaderConfig() {
    this.homeService.getHeaderConfig().subscribe(res => {
      this.header = res.return_body;
      this.getImage(this.header);
    });
  }

  redirect() {
    this.navigate = window.location.protocol + "//" + window.location.host + '/shp/' + this.homeService.shortName +'/home';
  }

  getImage(img) {
      this.smallImage = img.logo.smallImageURL;
      this.largeImage = img.logo.largeImageURL;
      if (this.screenWidth <= 768) {
        this.image = this.smallImage;
      } else {
        this.image = this.largeImage;
      }
  }
  
  handleNavigation(indexValue) {
    console.log("index value   : " +indexValue);
    if(indexValue == 0){
      this.router.navigate([this.router.url.split("/")[1],'helpcenter']);
    }
    if(indexValue == 1){
      this.checkCaseModal = true;
      // this.router.navigate([this.router.url.split("/")[1],'createcase']);
    }
    if(indexValue == 2){
      // if(this.authConfig.loginType == 'SHP SAML2Authenticator'){
      //   localStorage.setItem("isSamlLogin","true");
      //   this.authenticationService.login('samluser', null, String(this.homeService.institutionId),this.authConfig.loginType)
      //     .subscribe(
      //       data => {
      //         window.location.replace(environment.apiBaseURL+'/saml/login/alias/'+this.homeService.shortName+ '?idp=' + data.return_body.samlLoginUrl)
      //     });
      // } else{
      // this.router.navigate([this.router.url.split("/")[1],'login']);
      // }
      this.homeService.navigateToLogin(this.router.url.split("/")[1] + '/helpcenter');
    }
    else if(indexValue == 3){
      this.homeService.endChat.next(true);
      this.authenticationService.logout();
    }
  }

  checkIsPasswordModalOpen(event){
    this.checkPasswordModal = false;
  }

  checkIsCaseModalOpen(event){
    this.checkCaseModal = false;
  }
  // getLoginConfig() {
  //   setTimeout(() => {
  //       this.homeService.sendMessage(true);
  //       this.homeService.getLoginConfig().subscribe(res => {
            
  //           this.authConfig = res.return_body.authenticationConfig;
  //           this.loginSamlUrl = res.return_body.loginSamlUrl;
  //           this.homeService.sendMessage(false);
  //       });
  //   },0);   
  // }  
}
